import api from './api';

export interface DocumentoCompartidoResult {
  url: string;
  telefono: string | null;
  expiresAt: string;
}

export async function compartirDocumentoPdf(params: {
  blob: Blob;
  titulo: string;
  documentType?: string;
  documentId?: string;
  fileName?: string;
}): Promise<DocumentoCompartidoResult> {
  const form = new FormData();
  const rawName = params.fileName?.trim() || 'documento.pdf';
  const fileName = rawName.toLowerCase().endsWith('.pdf') ? rawName : `${rawName}.pdf`;
  form.append('archivo', params.blob, fileName);
  form.append('titulo', params.titulo);
  if (params.documentType) form.append('documentType', params.documentType);
  if (params.documentId) form.append('documentId', params.documentId);

  const { data } = await api.post<DocumentoCompartidoResult>('/api/documentos-compartidos', form);
  return data;
}
